import React, { useEffect, useState } from "react";
import { getJobResponsesApi, deleteJobResponseApi } from "Services/allApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete} from "react-icons/md";

const JobResponse = ({ job }) => {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [responseToDelete, setResponseToDelete] = useState(null);

  useEffect(() => {
    fetchJobResponses();
  }, [job]);

  const fetchJobResponses = async () => {
    setLoading(true);
    try {
      const response = await getJobResponsesApi(job.id);
      if (response && !response.error) {
        setResponses(response.data);
      } else {
        toast.error("Failed to fetch job responses!");
      }
    } catch (error) {
      toast.error("An unexpected error occurred!");
    }
    setLoading(false);
  };

  const handleDeleteClick = (response) => {
    setResponseToDelete(response);
    setDeleteModalOpen(true);
  };

  const confirmDeleteResponse = async () => {
    if (responseToDelete) {
      try {
        const response = await deleteJobResponseApi(responseToDelete.id);
        if (response && !response.error) {
          toast.success("Job response deleted successfully!");
          fetchJobResponses();
        } else {
          toast.error("Failed to delete job response!");
        }
      } catch (error) {
        toast.error("An unexpected error occurred!");
      }
      setDeleteModalOpen(false);
      setResponseToDelete(null);
    }
  };

  // const handleEditClick = (response) => {
  //   setResponseToEdit(response);
  //   setEditedResponse({
  //     name: response.name,
  //     email: response.email,
  //     resume: null, // To handle file upload
  //   });
  //   setEditModalOpen(true);
  // };

  // const handleEditChange = (e) => {
  //   const { name, value } = e.target;
  //   setEditedResponse((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  // const handleFileChange = (e) => {
  //   setEditedResponse((prev) => ({
  //     ...prev,
  //     resume: e.target.files[0], // Handle resume file upload
  //   }));
  // };

  // const confirmEditResponse = async () => {
  //   if (responseToEdit) {
  //     const formData = new FormData();
  //     formData.append("name", editedResponse.name);
  //     formData.append("email", editedResponse.email);
  //     if (editedResponse.resume) {
  //       formData.append("resume", editedResponse.resume);
  //     }

  //     try {
  //       const response = await editJobResponseApi(responseToEdit.id, formData);
  //       if (response && !response.error) {
  //         toast.success("Job response updated successfully!");
  //         fetchJobResponses();
  //       } else {
  //         toast.error("Failed to update job response!");
  //       }
  //     } catch (error) {
  //       toast.error("An unexpected error occurred!");
  //     }
  //     setEditModalOpen(false);
  //     setResponseToEdit(null);
  //     setEditedResponse({ name: "", email: "", resume: null });
  //   }
  // };

  return (
    <>
      <div className="w-full p-4 h-full  dark:bg-[#0b14374d] dark:text-white ">
        <div className="mb-8 flex justify-between items-center">
          {/* <h4 className="text-xl font-bold">Job Responses</h4> */}
          {/* <button onClick={() => navigate("/admin/job-post")} className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-purple-700">
            Back to Jobs
          </button> */}
        </div>

        {loading ? (
          <p className="text-center text-purple-800">Loading responses...</p>
        ) : responses.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5  dark:bg-[#0b14374d] dark:text-white ">
            {responses.map((response) => (
              <div key={response.id} className="flex justify-between bg-white p-4 rounded-lg shadow-md  dark:bg-gray-800 dark:text-white">
                <div>
                  <h5 className="font-medium">{response.name}</h5>
                  <p>Email: {response.email}</p>
                  <a href={response.resume} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                    View Resume
                  </a>
                </div>
                <div className="flex space-x-2 items-center">
                  {/* <MdEdit
                    onClick={() => handleEditClick(response)}
                    className="text-blue-500 hover:text-blue-700" size={22}
                  /> */}
                  <MdDelete
                    onClick={() => handleDeleteClick(response)}
                    className="text-red-500 hover:text-red-700" size={22}
                  />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-red-500">No job responses available.</p>
        )}
      </div>

      {/* Delete Confirmation Modal */}
      {deleteModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg w-96 text-center  dark:bg-gray-800  dark:text-white">
            <h2 className="text-lg font-bold mb-4">Confirm Delete</h2>
            <p className="mb-4">Are you sure you want to delete this job response?</p>
            <div className="flex justify-center space-x-4">
              <button className="bg-gray-500 text-white px-4 py-2 rounded" onClick={() => setDeleteModalOpen(false)}>
                Cancel
              </button>
              <button className="bg-red-500 text-white px-4 py-2 rounded" onClick={confirmDeleteResponse}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Job Response Modal
      {editModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg w-96">
            <h2 className="text-lg font-bold mb-4">Edit Job Response</h2>
            <div className="mb-4">
              <input
                type="text"
                name="name"
                value={editedResponse.name}
                onChange={handleEditChange}
                className="w-full px-4 py-2 border border-gray-300 rounded"
                placeholder="Enter name"
              />
            </div>
            <div className="mb-4">
              <input
                type="email"
                name="email"
                value={editedResponse.email}
                onChange={handleEditChange}
                className="w-full px-4 py-2 border border-gray-300 rounded"
                placeholder="Enter email"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm">Upload Resume (PDF)</label>
              <input
                type="file"
                accept="application/pdf"
                onChange={handleFileChange}
                className="w-full px-4 py-2 border border-gray-300 rounded"
              />
            </div>
            <div className="flex justify-center space-x-4">
              <button className="bg-gray-500 text-white px-4 py-2 rounded" onClick={() => setEditModalOpen(false)}>
                Cancel
              </button>
              <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={confirmEditResponse}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )} */}

      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />
    </>
  );
};

export default JobResponse;
